import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  standalone: true
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], searchQuery: string, ...fields: string[]): any[] {
    if (!items || !searchQuery || fields.length === 0) {
      return items;
    }
    
    searchQuery = searchQuery.toLowerCase();

    return items.filter(item =>
      fields.some(field => {
        const value = field.split('.').reduce((o, key) => (o ? o[key] : null), item);
        return value ? value.toString().toLowerCase().includes(searchQuery) : false;
      })
    );
  }
}
